import { store } from "../store/index";
import {
  filterCode,
  removeCode,
  modifyCode,
  getCodeByUuid,
  createCode,
  listAll,
} from "../store/actions/CodeActions";

/**
 * Create Code
 */
export const addCode = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createCode(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Code
 */
export const getCode = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getCodeByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Code
 */
export const updateCode = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyCode(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Code
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterCode(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List Code
 */
export const listAllCodes = async () => {
  const result = await store.dispatch(listAll());
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Code
 */
export const deleteCode = async (uuid) => {
  const result = await store.dispatch(removeCode([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
